import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'

export default class extends BaseComponent {

  render () {

    return (
      <section className="error-page">
        <div className="content">
    			<h1>404</h1>
  				<h3 className="error">Strona nie istnieje!</h3>
  				<NavLink to="/">&lt;&nbsp;&nbsp;Wróć do strony głównej</NavLink>
        </div>
        <Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ErrorPage.js